var _defs, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTornado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 27.5,
    y1: 12.21,
    x2: 36.5,
    y2: 27.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec1c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 28,
    y1: 19.07,
    x2: 36,
    y2: 32.93,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 28.63,
    y1: 26.15,
    x2: 35.38,
    y2: 37.85,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 29.25,
    y1: 33.24,
    x2: 34.75,
    y2: 42.76,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 30.25,
    y1: 40.97,
    x2: 33.75,
    y2: 47.03,
    xlinkHref: "#a"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 20,
    x2: 47,
    y2: 20,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#a)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "-3 0; 3 0; -3 0",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 26,
    x2: 45,
    y2: 26,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#b)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "-4 0; 4 0; -4 0",
    dur: "2s",
    begin: "-0.2s",
    repeatCount: "indefinite"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 32,
    x2: 42.5,
    y2: 32,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#c)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "-5 0; 5 0; -5 0",
    dur: "2s",
    begin: "-0.4s",
    repeatCount: "indefinite"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 38,
    x2: 40,
    y2: 38,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#d)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "-6 0; 6 0; -6 0",
    dur: "2s",
    begin: "-0.6s",
    repeatCount: "indefinite"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 36,
    y2: 44,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#e)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "-7 0; 7 0; -7 0",
    dur: "2s",
    begin: "-0.8s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTornado);
export default __webpack_public_path__ + "static/media/tornado.a5499a9fc663f38b5fb791c22be37342.svg";
export { ForwardRef as ReactComponent };